import { Box } from "../../box";
import { forwardRef } from "react";
import { slot } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerContent({
  as = DefaultElement,
  children,
  forwardedRef,
  ...rest
}) {
  return /*#__PURE__*/_jsx(Box, { ...rest,
    as: as,
    ref: forwardedRef,
    children: children
  });
}
InnerContent.defaultElement = DefaultElement;
export const Content = slot("content", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerContent, { ...props,
  forwardedRef: ref
})));